import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Pallet: FC<SvgIconProps> = ({ viewBox = '0 0 255 181', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props}>
    <path d="M43.4563 122.764V124.243L151.2 103.507V102.02L43.4563 122.764Z" fill="#996A0D" />
    <path d="M43.411 122.78L151.154 102.043L141.081 96.7511L33.3833 117.533L43.411 122.78Z" fill="#BC9361" />
    <path
      opacity="0.5"
      d="M120.886 107.841L141.143 103.973L131.041 98.6699L112.052 102.327L120.886 107.841Z"
      fill="url(#paint0_linear)"
    />
    <path
      opacity="0.5"
      d="M70.6633 117.511L90.8586 113.641L80.7733 108.346L61.774 112.003L70.6633 117.511Z"
      fill="url(#paint1_linear)"
    />
    <path d="M141.143 93.2599V103.973L131.068 98.6481V87.6931L141.143 93.2599Z" fill="#634509" />
    <path d="M141.143 92.9724V103.973L151.2 102.037V91.0493L141.143 92.9724Z" fill="#996A0D" />
    <path d="M90.8587 102.743V113.641L80.7858 108.346V97.178L90.8587 102.743Z" fill="#634509" />
    <path d="M90.8586 102.743V113.715L100.932 111.759V100.597L90.8586 102.743Z" fill="#996A0D" />
    <path d="M160.694 139.443L170.767 137.485L94.7927 97.5765L84.7197 99.5345L160.694 139.443Z" fill="#BC9361" />
    <path d="M80.7858 97.4698V99.1839L160.659 141.157V139.443L80.7858 97.4698Z" fill="#634509" />
    <path d="M77.3066 140.44L185.05 119.704L174.977 114.414L67.2336 135.15L77.3066 140.44Z" fill="#BC9361" />
    <path d="M174.977 110.004V121.826L164.902 116.455V104.439L174.977 110.004Z" fill="#634509" />
    <path d="M174.977 111.112V121.826L185.05 119.874V108.967L174.977 111.112Z" fill="#996A0D" />
    <path d="M77.3066 140.46V141.941L67.2336 136.653V135.15L77.3066 140.46Z" fill="#634509" />
    <path d="M77.3065 140.462V141.941L185.05 121.203V119.717L77.3065 140.462Z" fill="#996A0D" />
    <path d="M43.4563 122.762V124.243L33.3833 118.957V117.455L43.4563 122.762Z" fill="#634509" />
    <path d="M77.3066 129.773V140.486L67.2336 135.682V124.208L77.3066 129.773Z" fill="#634509" />
    <path d="M77.3065 129.773V141.941L87.3815 139.907V127.628L77.3065 129.773Z" fill="#996A0D" />
    <path d="M131.068 87.887V89.601L210.943 131.574V129.86L131.068 87.887Z" fill="#634509" />
    <path d="M43.4563 112.19V122.904L33.3833 117.533V106.624L43.4563 112.19Z" fill="#634509" />
    <path d="M43.4563 111.903V124.243L53.5313 122.311V109.965L43.4563 111.903Z" fill="#996A0D" />
    <path d="M210.927 129.854L221 127.896L145.026 87.985L134.953 89.943L210.927 129.854Z" fill="#BC9361" />
    <path d="M113.292 148.577L123.365 146.619L47.3924 106.711L37.3174 108.669L113.292 148.577Z" fill="#BC9361" />
    <path d="M43.4562 110.402L151.2 89.6663L141.127 84.3761L33.3833 105.112L43.4562 110.402Z" fill="#BC9361" />
    <path d="M43.4563 110.422V111.903L33.3833 106.615V105.112L43.4563 110.422Z" fill="#634509" />
    <path d="M43.4563 110.424V111.903L151.2 91.1648V89.6794L43.4563 110.424Z" fill="#996A0D" />
    <path d="M71.5548 125.178L179.298 104.441L169.223 99.149L61.4818 119.887L71.5548 125.178Z" fill="#BC9361" />
    <path d="M71.5548 125.195V126.678L61.4818 121.39V119.887L71.5548 125.195Z" fill="#634509" />
    <path d="M71.5547 125.199V126.678L179.298 105.94V104.454L71.5547 125.199Z" fill="#996A0D" />
    <path d="M85.3785 132.421L193.031 111.711L182.958 106.408L75.3055 127.131L85.3785 132.421Z" fill="#BC9361" />
    <path d="M85.3785 132.439V133.922L75.3055 128.634V127.131L85.3785 132.439Z" fill="#634509" />
    <path d="M85.3785 132.443V133.922L193.031 113.199V111.711L85.3785 132.443Z" fill="#996A0D" />
    <path d="M113.259 159.108L221 138.369L210.927 133.079L103.184 153.817L113.259 159.108Z" fill="#BC9361" />
    <path d="M210.927 129.568V140.282L200.854 135.017V124.004L210.927 129.568Z" fill="#634509" />
    <path d="M113.259 159.094V160.578L103.184 155.29V153.787L113.259 159.094Z" fill="#634509" />
    <path d="M113.259 159.099V160.578L221 139.839V138.354L113.259 159.099Z" fill="#996A0D" />
    <path d="M113.259 147.096V160.578L103.184 155.29V141.786L113.259 147.096Z" fill="#634509" />
    <path d="M113.259 148.464V159.175L123.332 157.224V146.317L113.259 148.464Z" fill="#996A0D" />
    <path d="M160.659 139.26V149.973L150.586 144.692V133.696L160.659 139.26Z" fill="#634509" />
    <path d="M160.659 138.862V151.182L170.732 149.466V137.115L160.659 138.862Z" fill="#996A0D" />
    <path d="M210.927 128.292V141.778L221 139.839V126.354L210.927 128.292Z" fill="#996A0D" />
    <path d="M113.259 147.096L221 126.354L210.927 121.048L103.184 141.786L113.259 147.096Z" fill="#BC9361" />
    <path d="M33.3833 106.604V108.318L113.259 150.291V148.577L33.3833 106.604Z" fill="#634509" />
    <path d="M113.259 147.096V148.577L103.184 143.289V141.786L113.259 147.096Z" fill="#634509" />
    <path d="M113.259 147.098V148.577L221 127.839V126.354L113.259 147.098Z" fill="#996A0D" />
    <path d="M99.503 139.907L207.244 119.171L197.171 113.881L89.428 134.617L99.503 139.907Z" fill="#BC9361" />
    <path d="M99.503 139.927V141.408L89.428 136.119V134.617L99.503 139.927Z" fill="#634509" />
    <path d="M99.5028 139.929V141.408L207.244 120.669V119.184L99.5028 139.929Z" fill="#996A0D" />
    <path
      opacity="0.5"
      d="M140.476 153.857L160.659 149.973L150.586 144.692L131.587 148.351L140.476 153.857Z"
      fill="url(#paint2_linear)"
    />
    <path
      opacity="0.5"
      d="M190.697 144.189L210.927 140.288L200.854 135.017L181.865 138.672L190.697 144.189Z"
      fill="url(#paint3_linear)"
    />
    <path d="M57.5806 117.851L165.324 97.1126L155.249 91.8224L47.5077 112.561L57.5806 117.851Z" fill="#BC9361" />
    <path d="M57.5806 117.851V119.334L47.5077 114.046V112.543L57.5806 117.851Z" fill="#634509" />
    <path d="M57.5807 117.855V119.334L165.324 98.5958V97.1083L57.5807 117.855Z" fill="#996A0D" />
    <path
      opacity="0.5"
      d="M67.4663 122.311L81.2407 119.654L58.2539 107.569L44.4816 110.226L67.4663 122.311Z"
      fill="url(#paint4_linear)"
    />
    <path
      opacity="0.5"
      d="M29.9104 127.077L43.4563 124.243L33.3813 118.949L19.8334 121.78L29.9104 127.077Z"
      fill="url(#paint5_linear)"
    />
    <path
      opacity="0.5"
      d="M63.7608 144.775L77.3066 141.943L67.2316 136.646L53.6837 139.48L63.7608 144.775Z"
      fill="url(#paint6_linear)"
    />
    <path
      opacity="0.5"
      d="M99.7109 163.403L113.259 160.569L103.182 155.274L89.6338 158.106L99.7109 163.403Z"
      fill="url(#paint7_linear)"
    />
    <path d="M81.2407 81.2551L121.623 73.5997L98.6363 61.5143L58.2539 69.1697L81.2407 81.2551Z" fill="#FDDE84" />
    <path
      opacity="0.4"
      d="M71.3365 76.0477L111.719 68.3923L107.896 66.3885L67.4601 74.007L71.3365 76.0477Z"
      fill="#AA7B33"
    />
    <path d="M81.2407 81.255V119.654L58.2539 107.569V69.1697L81.2407 81.255Z" fill="#C39000" />
    <path opacity="0.4" d="M71.3346 76.0477V84.3652L67.4561 82.2548V74.007L71.3346 76.0477Z" fill="#AA7B33" />
    <path d="M81.2407 81.2551V119.654L121.623 111.999V73.5996L81.2407 81.2551Z" fill="#FCCE09" />
    <path d="M93.0697 97.1235V111.57L116.643 107.094V92.6478L93.0697 97.1235Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.663 106.177C108.061 105.918 109.413 105.665 110.797 105.41C110.797 102.533 110.797 99.6716 110.797 96.7946C109.409 97.0516 108.054 97.3042 106.663 97.5612C106.663 100.449 106.663 103.311 106.663 106.177Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M95.295 108.283C96.4973 108.059 97.6501 107.845 98.7906 107.634C98.7906 104.751 98.7906 101.887 98.7906 99.0183C97.6028 99.2383 96.4664 99.4495 95.295 99.6673C95.295 102.56 95.295 105.424 95.295 108.283Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M102.661 106.92C103.239 106.813 103.783 106.711 104.384 106.6C104.384 103.718 104.384 100.854 104.384 97.9924C103.783 98.1035 103.227 98.208 102.661 98.3126C102.661 101.192 102.661 104.049 102.661 106.92Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M114.418 96.1194C113.817 96.2305 113.255 96.335 112.662 96.4461C112.662 99.3362 112.662 102.2 112.662 105.064C113.273 104.951 113.835 104.846 114.418 104.737C114.418 101.858 114.418 98.9943 114.418 96.1194Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.685 107.294C100.925 107.249 101.123 107.214 101.389 107.164C101.389 104.278 101.389 101.416 101.389 98.55C101.123 98.6001 100.897 98.6415 100.685 98.6807C100.685 101.562 100.685 104.424 100.685 107.294Z"
      fill="black"
    />
    <path
      opacity="0.5"
      d="M130.632 126.687L144.61 124.082L121.625 111.997L107.844 114.612L130.632 126.687Z"
      fill="url(#paint8_linear)"
    />
    <path d="M144.61 85.6828L184.992 78.0296L162.007 65.942L121.625 73.5975L144.61 85.6828Z" fill="#FDDE84" />
    <path
      opacity="0.4"
      d="M134.708 80.4754L175.088 72.82L171.265 70.8163L130.829 78.4369L134.708 80.4754Z"
      fill="#AA7B33"
    />
    <path d="M144.61 85.6828V124.082L121.625 111.997V73.5974L144.61 85.6828Z" fill="#C39000" />
    <path opacity="0.4" d="M134.704 80.4754L134.706 88.793L130.827 86.6826V78.4369L134.704 80.4754Z" fill="#AA7B33" />
    <path d="M144.61 85.6828V124.082L184.992 116.429V78.0295L144.61 85.6828Z" fill="#FCCE09" />
    <path d="M156.441 101.554V116L180.014 111.522V97.0757L156.441 101.554Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M170.034 110.605C171.432 110.346 172.785 110.093 174.168 109.838C174.168 106.961 174.168 104.099 174.168 101.222C172.78 101.479 171.426 101.732 170.034 101.989C170.034 104.877 170.034 107.739 170.034 110.605Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M158.666 112.713C159.869 112.489 161.021 112.275 162.162 112.064C162.162 109.181 162.162 106.317 162.162 103.448C160.974 103.668 159.838 103.879 158.666 104.097C158.666 106.987 158.666 109.851 158.666 112.713Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M166.032 111.35C166.611 111.243 167.154 111.141 167.755 111.03C167.755 108.148 167.755 105.284 167.755 102.422C167.154 102.534 166.598 102.638 166.032 102.743C166.032 105.62 166.032 108.477 166.032 111.35Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M177.789 100.547C177.188 100.658 176.626 100.763 176.033 100.874C176.033 103.764 176.033 106.628 176.033 109.492C176.644 109.379 177.206 109.274 177.789 109.165C177.789 106.286 177.789 103.422 177.789 100.547Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M164.056 111.722C164.297 111.676 164.494 111.642 164.76 111.592C164.76 108.706 164.76 105.844 164.76 102.978C164.494 103.028 164.268 103.069 164.056 103.108C164.056 105.99 164.056 108.854 164.056 111.722Z"
      fill="black"
    />
    <path
      opacity="0.5"
      d="M107.723 76.235L121.635 73.5954L98.6506 61.51L84.7383 64.1497L107.723 76.235Z"
      fill="url(#paint9_linear)"
    />
    <path d="M121.635 35.1961L162.018 27.5407L139.033 15.4553L98.6506 23.1108L121.635 35.1961Z" fill="#FDDE84" />
    <path
      opacity="0.4"
      d="M111.731 29.9887L152.114 22.3333L148.291 20.3296L107.855 27.948L111.731 29.9887Z"
      fill="#AA7B33"
    />
    <path d="M121.635 35.1961V73.5952L98.6506 61.5099V23.1107L121.635 35.1961Z" fill="#C39000" />
    <path opacity="0.4" d="M111.729 29.9887V38.3062L107.853 36.1958V27.948L111.729 29.9887Z" fill="#AA7B33" />
    <path d="M121.635 35.1961V73.5953L162.018 65.9398V27.5406L121.635 35.1961Z" fill="#FCCE09" />
    <path d="M133.464 51.0645V65.5107L157.04 61.0351V46.5867L133.464 51.0645Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M147.06 60.1183C148.458 59.8591 149.81 59.6065 151.193 59.3517C151.193 56.4746 151.193 53.6128 151.193 50.7357C149.806 50.9927 148.451 51.2454 147.06 51.5024C147.06 54.3881 147.06 57.2521 147.06 60.1183Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M135.692 62.2243C136.894 62 138.047 61.7865 139.187 61.5753C139.187 58.6917 139.187 55.8277 139.187 52.9594C138 53.1793 136.863 53.3906 135.692 53.6084C135.692 56.5007 135.692 59.3647 135.692 62.2243Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M143.056 60.8609C143.634 60.7542 144.177 60.6519 144.779 60.5408C144.779 57.6594 144.779 54.7954 144.779 51.9336C144.177 52.0447 143.622 52.1492 143.056 52.2537C143.056 55.1308 143.056 57.9904 143.056 60.8609Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154.813 50.0605C154.211 50.1716 153.649 50.2762 153.057 50.3872C153.057 53.2774 153.057 56.1413 153.057 59.0053C153.668 58.8921 154.23 58.7875 154.813 58.6786C154.813 55.7994 154.813 52.9354 154.813 50.0605Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M141.079 61.2355C141.32 61.1898 141.518 61.1549 141.783 61.1048C141.783 58.2191 141.783 55.3572 141.783 52.4911C141.518 52.5412 141.291 52.5826 141.079 52.6218C141.079 55.5032 141.079 58.365 141.079 61.2355Z"
      fill="black"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="123.626"
        y1="109.318"
        x2="129.803"
        y2="97.8598"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="73.3589"
        y1="118.964"
        x2="79.5221"
        y2="107.53"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="143.163"
        y1="155.307"
        x2="149.33"
        y2="143.866"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="193.421"
        y1="145.656"
        x2="199.605"
        y2="134.186"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="60.8752"
        y1="119.063"
        x2="65.2135"
        y2="111.015"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="29.6817"
        y1="127.089"
        x2="33.9716"
        y2="119.131"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="63.5321"
        y1="144.788"
        x2="67.822"
        y2="136.83"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint7_linear"
        x1="99.4826"
        y1="163.415"
        x2="103.772"
        y2="155.457"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint8_linear"
        x1="124.249"
        y1="123.455"
        x2="128.571"
        y2="115.437"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint9_linear"
        x1="101.19"
        y1="73.0178"
        x2="105.552"
        y2="64.9255"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
